import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PatientSearch } from './PatientSearch';
import { PatientView } from './PatientView';

interface PatientsProps {
    match: { url: string };
}

// Type assertions for TypeScript 5.x compatibility with react-router-dom v5
const SwitchComponent = Switch as any;
const RouteComponent = Route as any;

export function Patients({ match }: PatientsProps) {
    return (
        <SwitchComponent>
            <RouteComponent path={`${match.url}/:id`} component={PatientView} exact />
            <RouteComponent path={`${match.url}/`} component={PatientSearch} exact />
        </SwitchComponent>
    );
}
